<h2
  class="lg:mt-10 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]"
>
  Review and Rating
</h2>

<section
  class="container mx-auto px-4 md:py-6"
  *ngIf="userrating.length > 0; else noReviews"
>
  <!-- Use a single grid for all items -->
  <section
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start"
  >
    <div
      *ngFor="let item of userrating"
      class="p-4 bg-purple-50 rounded-lg shadow-sm text-center transform duration-500 hover:-translate-y-2 cursor-pointer"
    >
      <img
        [src]="myRatingImageUrl + item?.images || 'assets/default-product.png'"
        alt="{{ item?.productName || 'Product Image' }}"
        class="object-cover w-40 h-40 mx-auto rounded-md mb-3"
      />

      <h1 class="text-lg font-semibold mb-2">
        {{ item?.product?.productDetails?.productName }}
        <span class="text-gray-700 font-normal">
          | Rs.{{ item?.product?.priceInventoryShippingInfo?.sellingPrice }}
        </span>
      </h1>

      <button
        class="p-1 px-6 mt-2 mb-4 text-black border-b-2 border-purple-600 font-bold hover:text-purple-700"
      >
        Review On This Product
      </button>

      <!-- Star Rating -->
      <div class="flex justify-center items-center space-x-1 mb-3">
        <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
          <svg
            class="w-4 h-4 mx-px fill-current"
            [ngClass]="{
              'text-orange-500': i < item.rating,
              'text-gray-300': i >= item.rating
            }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
          >
            <path
              d="M6.43 12l-2.36 1.64a1 1 0 0 1-1.53-1.11l.83-2.75a1 1 0 0 0-.35-1.09L.73 6.96a1 1 0 0 1 .59-1.8l2.87-.06a1 1 0 0 0 .92-.67l.95-2.71a1 1 0 0 1 1.88 0l.95 2.71c.13.4.5.66.92.67l2.87.06a1 1 0 0 1 .59 1.8l-2.3 1.73a1 1 0 0 0-.34 1.09l.83 2.75a1 1 0 0 1-1.53 1.1L7.57 12a1 1 0 0 0-1.14 0z"
            ></path>
          </svg>
        </ng-container>
        <span class="text-sm font-medium text-gray-700">{{ item.rating }}/5</span>
      </div>

      <p class="text-gray-700 text-sm">{{ item?.reviewText }}</p>
    </div>
  </section>
</section>

<!-- No Reviews Template -->
<ng-template #noReviews>
  <div
    class="flex flex-col items-center justify-center text-center py-10"
  >
    <svg
      class="w-20 h-20 text-purple-700"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 14c0 0 1.5 2 3 2s3-2 3-2m6-2a9 9 0 11-18 0 9 9 0 0118 0zm-6-3h.01M9 11h.01"
      />
    </svg>
    <h1 class="text-purple-700 font-medium text-lg mt-4">
      No Reviews & Ratings
    </h1>
    <p class="text-gray-600 mt-2">
      You have not rated or reviewed any product yet!
    </p>
  </div>
</ng-template>
